// import WebPortalProvider from './webportal'
import AuthProvider from './auth'
import LmgProvider from './lmg'

 const AuthService =  new AuthProvider('wms')
 const LmgService =  new LmgProvider('tld')

 export {AuthService,LmgService}
